module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp3_7016.46415d59.png";